module.exports = __webpack_public_path__ + "HSA Flyer.pdf";